/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateFlipbookFromPdfResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfFlipbookFromDiscriminatorValue, type CreateFlipbookFromPdfResponse, type ErrorResponse, type InternalErrorResponse, type PagedResultOfFlipbook } from '../../models/index.js';
// @ts-ignore
import { type WithFlipbookItemRequestBuilder, WithFlipbookItemRequestBuilderNavigationMetadata, WithFlipbookItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/flipbooks
 */
export interface FlipbooksRequestBuilder extends BaseRequestBuilder<FlipbooksRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.flipbooks.item collection
     * @param flipbookId Unique identifier of the item
     * @returns {WithFlipbookItemRequestBuilder}
     */
     byFlipbookId(flipbookId: string) : WithFlipbookItemRequestBuilder;
    /**
     * List Flipbooks. Sales reps with multiple organizations can pass the OrgCodes header and UseOrganizationId to list flipbooks for a specific organization they have access to.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfFlipbook>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<FlipbooksRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfFlipbook | undefined>;
    /**
     * Upload a PDF file to create a new Flipbook with each page converted to an image
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateFlipbookFromPdfResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateFlipbookFromPdfResponse | undefined>;
    /**
     * List Flipbooks. Sales reps with multiple organizations can pass the OrgCodes header and UseOrganizationId to list flipbooks for a specific organization they have access to.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<FlipbooksRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Upload a PDF file to create a new Flipbook with each page converted to an image
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * List Flipbooks. Sales reps with multiple organizations can pass the OrgCodes header and UseOrganizationId to list flipbooks for a specific organization they have access to.
 */
export interface FlipbooksRequestBuilderGetQueryParameters {
    filters?: string[];
    pageNumber?: number;
    pageSize?: number;
    sortDirection?: string;
    sortOn?: string;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const FlipbooksRequestBuilderUriTemplate = "{+baseurl}/api/flipbooks?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}{&filters*,useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FlipbooksRequestBuilderNavigationMetadata: Record<Exclude<keyof FlipbooksRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFlipbookId: {
        requestsMetadata: WithFlipbookItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithFlipbookItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["flipbookId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FlipbooksRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FlipbooksRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfFlipbookFromDiscriminatorValue,
    },
    post: {
        uriTemplate: FlipbooksRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateFlipbookFromPdfResponseFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
